import React from 'react';

import MemberManagementEdit from '../../controls/maintenance/member/MemberManagementEdit';

const MemberEditSection = () => {
  return <MemberManagementEdit />;
};

export default MemberEditSection;
